import update from 'react-addons-update';
import { generateNewCollection, convertToCamelcase } from './collections.middleware';
import {
    API_CLEAR_COLLECTIONS,
    API_CREATE_COLLECTION,
    API_FETCH_COLLECTIONS,
    API_CREATE_COLLECTION_FAILED,
    API_CLEAR_COLLECTIONS_ERROR,
    API_SAVE_TILE_COLLECTIONS,
    API_SAVE_TILE_COLLECTIONS_FAILED,
    API_DELETE_COLLECTION,
    API_UPDATE_COLLECTION,
    API_UPDATE_COLLECTION_FAILED,
    API_COPY_COLLECTION,
    API_COPY_COLLECTION_FAILED
} from '../actionTypes';

const initialCollectionState: Collections = { collections: [], errorMessage: '', collectionsLoaded: false, imgSrc: '' };

const reducer = (
    state: Collections = initialCollectionState,
    incomingAction:
        | CreateCollectionAction
        | FetchCollectionsAction
        | CreateCollectionFailedAction
        | SaveTileCollectionsAction
        | SaveTileCollectionsFailedAction
        | DeleteCollectionAction
        | UpdateCollectionAction
        | UpdateCollectionFailedAction
) => {
    const action = incomingAction;
    switch (action.type) {
        case API_CREATE_COLLECTION: {
            const actionObj = action as CreateCollectionAction;
            const newCollection: Collection = generateNewCollection(actionObj.response);
            const { collections } = state as any;
            return update(state, { collections: { $set: [...collections, newCollection] }, errorMessage: { $set: '' } });
        }
        case API_UPDATE_COLLECTION: {
            const actionObj = action as UpdateCollectionAction;
            const updatedCollection: Collection = generateNewCollection(actionObj.response);
            const { collections } = state as any;
            const updatedCollections = collections.map((col: Collection) => (col.collectionId === updatedCollection.collectionId ? { ...col, name: updatedCollection.name, description: updatedCollection.description } : col));
            return update(state, { collections: { $set: updatedCollections }, errorMessage: { $set: '' } });
        }
        case API_UPDATE_COLLECTION_FAILED: {
            const actionObj = action as UpdateCollectionFailedAction;
            return update(state, { errorMessage: { $set: actionObj.response.message } });
        }
        case API_CREATE_COLLECTION_FAILED: {
            const actionObj = action as CreateCollectionFailedAction;
            return update(state, { errorMessage: { $set: actionObj.response.message } });
        }
        case API_COPY_COLLECTION: {
            const actionObj = action as CreateCollectionAction;
            const newCollection: Collection = generateNewCollection(actionObj.response);
            const { collections } = state as any;
            return update(state, { collections: { $set: [...collections, newCollection] }, errorMessage: { $set: '' } });
        }
        case API_COPY_COLLECTION_FAILED: {
            const actionObj = action as CreateCollectionFailedAction;
            return update(state, { errorMessage: { $set: actionObj.response.message } });
        }
        case API_FETCH_COLLECTIONS: {
            const actionObj = action as FetchCollectionsAction;
            const converted: Collection | Collection[] = convertToCamelcase(actionObj.response.Collections);
            const imgSrc = actionObj.response.ImgSrc || '';
            const allCollections: Collection[] = Array.isArray(converted) ? converted : [converted];
            return update(state, { collections: { $set: allCollections }, errorMessage: { $set: '' }, collectionsLoaded: { $set: true }, imgSrc: { $set: imgSrc } });
        }
        case API_DELETE_COLLECTION: {
            const actionObj = action as DeleteCollectionAction;
            const { collections } = state as any;
            const updatedCollections = collections.filter((collection: Collection) => collection.collectionId !== (actionObj.response as any).collectionId);
            return update(state, { collections: { $set: updatedCollections }, errorMessage: { $set: '' } });
        }
        case API_SAVE_TILE_COLLECTIONS: {
            const actionObj = action as SaveTileCollectionsAction;
            const { payload } = actionObj.response;
            const { collections } = state as any;

            // Update collections based on added/removed IDs
            const updatedCollections = collections.map((col: Collection) => {
                const { collectionId } = col;
                const wasAdded = payload.addedCollectionIds.includes(collectionId);
                const wasRemoved = payload.removedCollectionIds.includes(collectionId);

                if (!wasAdded && !wasRemoved) return col;

                const criteria = { ...col.criteria };
                // Map singular tile type to plural criteria key
                let criteriaKey: keyof CollectionCriteria = 'datasets';
                if (payload.tileType === 'solution') {
                    criteriaKey = 'solutions';
                } else if (payload.tileType === 'blueprint') {
                    criteriaKey = 'blueprints';
                } else if (payload.tileType === 'bundle') {
                    criteriaKey = 'bundles';
                }

                if (wasAdded && !criteria[criteriaKey].includes(payload.tileId)) {
                    criteria[criteriaKey] = [...criteria[criteriaKey], payload.tileId];
                } else if (wasRemoved) {
                    criteria[criteriaKey] = criteria[criteriaKey].filter(id => id !== payload.tileId);
                }

                return {
                    ...col,
                    criteria,
                    criteriaCount: criteria.datasets.length + criteria.bundles.length + criteria.solutions.length + criteria.blueprints.length
                };
            });

            return update(state, { collections: { $set: updatedCollections }, errorMessage: { $set: '' } });
        }
        case API_SAVE_TILE_COLLECTIONS_FAILED: {
            const actionObj = action as SaveTileCollectionsFailedAction;
            return update(state, { errorMessage: { $set: actionObj.response.message } });
        }
        case API_CLEAR_COLLECTIONS: {
            return update(state, { collections: { $set: [] }, errorMessage: { $set: '' }, collectionsLoaded: { $set: false }, imgSrc: { $set: '' } });
        }
        case API_CLEAR_COLLECTIONS_ERROR: {
            return update(state, { errorMessage: { $set: '' } });
        }
        default:
            return state || initialCollectionState;
    }
};

export { reducer, initialCollectionState };
